import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

import { EndorsementRoutes } from "@routing/paths";

import { STEP_LABEL } from "../constants";

export function EndorsementLayoutStepper({
  steps,
  currentStep,
  lockedSteps,
}: {
  steps: EndorsementRoutes[];
  currentStep: EndorsementRoutes;
  lockedSteps: EndorsementRoutes[];
}) {
  const theme = useTheme();
  return (
    <Box
      display="flex"
      alignItems="center"
      gap={3}
      px={3}
      py={1.5}
      fontSize={16}
      borderBottom={`1px solid ${theme.palette.divider}`}>
      {steps.map((step, index) => {
        const isActive = step === currentStep;
        const isLocked = lockedSteps.includes(step);
        return (
          <Box
            key={step}
            display="flex"
            alignItems="center"
            gap={0.5}
            sx={{
              position: "relative",
            }}>
            <Typography
              variant="caption"
              fontSize="inherit"
              fontWeight={isActive ? 500 : 400}
              color={isActive ? "text.primary" : "text.secondary"}
              sx={{ userSelect: "none" }}>
              {String(index + 1).padStart(2, "0")} {STEP_LABEL[step]}
            </Typography>
            {isLocked && (
              <LockOutlinedIcon
                fontSize="inherit"
                color={isActive ? "inherit" : "disabled"}
                data-testid={`${step}-lock-icon`}
              />
            )}
            {isActive && (
              <Box
                sx={{
                  position: "absolute",
                  bottom: theme.spacing(-1.65),
                  left: 0,
                  right: 0,
                  height: 2,
                  bgcolor: "success.main",
                  borderRadius: 1,
                }}
              />
            )}
          </Box>
        );
      })}
    </Box>
  );
}
